import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { VhImage, VhQueryAutoWeb, VhEventMediator } from 'vhautowebdb';
import { HttpClient } from '@angular/common/http';
import { MatDialog } from '@angular/material/dialog';
import { forkJoin } from 'rxjs';
// import { FunctionService } from 'vhobjects-service';
// import { ManageLibraryComponent } from '../../../.././manage-library/manage-library.component';
import { FunctionService } from 'vhobjects-service/src/services';
import { isPlatformBrowser } from '@angular/common';
import { PLATFORM_ID, Inject } from '@angular/core';
import { ChooseImageComponent, ManageLibraryComponent } from 'vhobjects-service';
import { AtwEditImage } from '../edit-image/edit-image.component';
import { LanguageService } from 'vhobjects-service/src/services';
import { NzImageService } from 'ng-zorro-antd/image';
// import { FunctionService } from 'src/app/services/function.service';
// import { DynamicDataPathService, DynamicPathBuilderStep } from 'src/app/services/dynamic-data-path.service';

@Component({
  selector: 'atw-image-config',
  templateUrl: './image-config.component.html',
  styleUrls: ['./image-config.component.scss'],
})
export class AtwImageConfig implements OnInit {
  isCollapsed: boolean = false;
  isShowConfirmPopup: boolean = false;
  isConfirmLoading: boolean = false; // biến kiểm tra khi đang xử lý dữ liệu
  isViewAll: boolean = false; // biến flag để hiện thị phần mở rộng cấu hình
  currentViewAll: any = {};
  @Input() objectChoosing: any; // lấy giá trị data trả vể từ page
  @Input() type: any; // xem đang ở page hay admin
  @Input() device: any; // xác định device là desktop hay mobile
  @Input() class: any; // là dữ liệu desktop_class hoặc mobile_class từ database
  @Input() staticdata: any; // là dữ liệu staticdata từ database
  @Input() config: any; // là dữ liệu desktop_config hoặc mobile_config từ database
  @Input() blocks_of_page?: any; // lấy dữ liệu blocks_of_page trên page
  effect_hover = [];
  isApplyShadow: boolean = false; // Cho phép thêm | chỉnh sửa bóng
  effect_hover_data: any = {};
  @Input() visible_config_tool = false; // biến kiểm tra đóng mở khi gọi hộp thoại
  previewUploadUrl: string | null = null; // url preview trong vùng kéo thả
  dragging = false; // biến kiểm tra người dùng dùng rời con trỏ khỏi vùng upload mà chưa thả
  customize = [];
  style_fields = [
    {
      title: "thong_so_co_ban",
      index: 1,
      isDrop: false
    },
    {
      title: "bo_loc_hinh_anh",
      index: 2,
      isDrop: false
    },
    {
      title: "do_bao_phu",
      index: 3,
      isDrop: false
    },
    {
      title: "bo_tron",
      index: 4,
      isDrop: false
    },
    {
      title: "do_bong",
      index: 5,
      isDrop: false
    },
    {
      title: "cau_hinh_chi_tiet_hieu_ung",
      index: 6,
      isDrop: false
    },
    {
      title: "bien_doi",
      index: 7,
      isDrop: false
    }, {
      title: "them_lien_ket",
      index: 8,
      isDrop: false
    },
    {
      title: 'do_bao_phu',
      index: 9,
      isDrop: false,
    },
    {
      title: 'dieu_chinh_vien',
      index: 10,
    },
    {
      title: 'nen_bieu_tuong',
      index: 11,
    },
  ];
  // Mảng chứa nội dung các kiểu bóng định sẵn
  shadow_styles: any = [
    {
      name: 'Kiểu 1',
      objectChoosing: 'rgba(100, 100, 111, 0.2) 0px 7px 29px 0px',
      img: '/assets/root/images/system/imgs/box-shadow-1.jpg',
    },
    {
      name: 'Kiểu 2',
      objectChoosing: 'rgba(0, 0, 0, 0.15) 1.95px 1.95px 2.6px',
      img: '/assets/root/images/system/imgs/box-shadow-2.jpg',
    },
    {
      name: 'Kiểu 3',
      objectChoosing: 'rgba(0, 0, 0, 0.24) 0px 3px 8px',
      img: '/assets/root/images/system/imgs/box-shadow-3.jpg',
    },
    {
      name: 'Kiểu 4',
      objectChoosing:
        'rgba(0, 0, 0, 0.16) 0px 1px 4px, rgb(51, 51, 51) 0px 0px 0px 3px',
      img: '/assets/root/images/system/imgs/box-shadow-4.jpg',
    },
    {
      name: 'Kiểu 5',
      objectChoosing:
        'rgba(0, 0, 0, 0.25) 0px 54px 55px, rgba(0, 0, 0, 0.12) 0px -12px 30px, rgba(0, 0, 0, 0.12) 0px 4px 6px, rgba(0, 0, 0, 0.17) 0px 12px 13px, rgba(0, 0, 0, 0.09) 0px -3px 5px',
      img: '/assets/root/images/system/imgs/box-shadow-5.jpg',
    },
    {
      name: 'Kiểu 6',
      objectChoosing:
        'rgba(0, 0, 0, 0.16) 0px 10px 36px 0px, rgba(0, 0, 0, 0.06) 0px 0px 0px 1px',
      img: '/assets/root/images/system/imgs/box-shadow-6.jpg',
    },
    {
      name: 'Kiểu 7',
      objectChoosing:
        'rgba(50, 50, 93, 0.25) 0px 13px 27px -5px, rgba(0, 0, 0, 0.3) 0px 8px 16px -8px',
      img: '/assets/root/images/system/imgs/box-shadow-7.jpg',
    },
    {
      name: 'Kiểu 8',
      objectChoosing: 'rgb(38, 57, 77) 0px 20px 30px -10px',
      img: '/assets/root/images/system/imgs/box-shadow-8.jpg',
    },
    {
      name: 'Kiểu 9',
      objectChoosing:
        'rgba(50, 50, 93, 0.25) 0px 13px 27px -5px, rgba(0, 0, 0, 0.3) 0px 8px 16px -8px',
      img: '/assets/root/images/system/imgs/box-shadow-9.jpg',
    },
    {
      name: 'Kiểu 10',
      objectChoosing:
        'rgba(0, 0, 0, 0.19) 0px 10px 20px, rgba(0, 0, 0, 0.23) 0px 6px 6px',
      img: '/assets/root/images/system/imgs/box-shadow-10.jpg',
    },
    {
      name: 'Kiểu 11',
      objectChoosing:
        'rgba(0, 0, 0, 0.25) 0px 14px 28px, rgba(0, 0, 0, 0.22) 0px 10px 10px',
      img: '/assets/root/images/system/imgs/box-shadow-11.jpg',
    },
    {
      name: 'Kiểu 12',
      objectChoosing:
        'rgba(0, 0, 0, 0.3) 0px 19px 38px, rgba(0, 0, 0, 0.22) 0px 15px 12px',
      img: '/assets/root/images/system/imgs/box-shadow-12.jpg',
    },
    {
      name: 'Kiểu 13',
      objectChoosing:
        'rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px',
      img: '/assets/root/images/system/imgs/box-shadow-13.jpg',
    },
    {
      name: 'Kiểu 14',
      objectChoosing:
        'rgba(0, 0, 0, 0.09) 0px 2px 1px, rgba(0, 0, 0, 0.09) 0px 4px 2px, rgba(0, 0, 0, 0.09) 0px 8px 4px, rgba(0, 0, 0, 0.09) 0px 16px 8px, rgba(0, 0, 0, 0.09) 0px 32px 16px',
      img: '/assets/root/images/system/imgs/box-shadow-14.jpg',
    },
    {
      name: 'Kiểu 15',
      objectChoosing: 'rgba(0, 0, 0, 0.45) 0px 25px 20px -20px',
      img: '/assets/root/images/system/imgs/box-shadow-15.jpg',
    },
  ];
  /** Có nên mở nút cập nhật kích thước ảnh cho bằng kích thước thiết kế hay không */
  isDesignImageSizeValid: boolean = true;
  id_subproject: any;
  imageDeviceWidthMax: string = 'desktop'; // biến này để lưu thiết bị có hình ảnh width lớn nhất
  widthImageMax: number = 0;
  heightImageMax: number = 0;
  subproject = null;
  resolution = null;

  constructor(
    public vhQueryAutoWeb: VhQueryAutoWeb,
    private dialog: MatDialog,
    private http: HttpClient,
    private vhEventMediator: VhEventMediator,
    private vhImage: VhImage,
    private matdialog: MatDialog,
    // public dynamicDataPathService: DynamicDataPathService,
    public functionService: FunctionService,
    @Inject(PLATFORM_ID) private platformId: Object,
    private languageService: LanguageService,
    private nzImageService: NzImageService,
  ) {

  }

  async ngOnInit(): Promise<void> {
    this.id_subproject = this.vhQueryAutoWeb.getlocalSubProject_Working()._id;

    this.subproject = this.vhQueryAutoWeb.getlocalSubProject(
      this.vhQueryAutoWeb.getlocalSubProject_Working()._id
    );
    this.resolution = this.subproject.resolution;

    this.isDesignImageSizeValid = await this.checkDesignImageSize();

    // Kiểm tra nếu chưa có config thì thêm để người dùng không cần xóa thêm lại
    if (!this.config.hasOwnProperty('position_onscroll')) {
      this.config.position_onscroll = {
        type: 0,
        top: 0,
      };
    }

    if (!this.config.hasOwnProperty('is_top_page')) this.config.is_top_page = false;
    if (!this.objectChoosing.setups?.upload_image?.compressWidth)
      this.objectChoosing.setups.upload_image.compress_width = 100;
    if (!this.objectChoosing.setups?.upload_image?.compressHeight)
      this.objectChoosing.setups.upload_image.compress_height = 100;
    if (!this.config['image-fullscreen']?.hasOwnProperty('toggle_fullscreen')) {
      this.config['image-fullscreen'] ??= {};
      this.config['image-fullscreen'].toggle_fullscreen = false;
    }

    // phần này get dữ liệu json
    forkJoin([
      this.http.get('assets/data/effects/image.json'),
    ]).subscribe(([effects]: any) => {
      this.effect_hover = effects;
      this.effect_hover_data = this.effect_hover.find(
        (e) => e.type == this.staticdata[this.device + '_animation_type']
      );
    });
  }

  async ngOnChanges(changes: SimpleChanges): Promise<void> {
    this.isDesignImageSizeValid = await this.checkDesignImageSize();
    if (!this.staticdata.accessibility) this.staticdata.accessibility = {};
    if (this.class['image']?.['background-image'] && this.class['image']['background-image'].includes('url(')) {
      this.class['image']['background-image'] = 'none';
    }
    this.staticdata.img_fullscreen ??= {};
    this.functionService.devices.forEach((device) => {
      this.staticdata.img_fullscreen[device.value + '_img'] ??= 'https://img.freepik.com/free-photo/green-field-tree-blue-skygreat-as-backgroundweb-banner-generative-ai_1258-153069.jpg';
    });

    if (this.effect_hover) {
      this.effect_hover_data = this.effect_hover.find(
        (e) => e.type == this.staticdata[this.device + '_animation_type']
      );
      this.customize = this.effect_hover_data?.data?.find(e => e.id == this.config['animation-selected']?.id)?.customize || [];
    }
    if (changes.device) {
      this.getWidthHeightImage();
    }
  }

  handleOpenFullscreenPreview() {
    const srcTemp = this.staticdata.img_fullscreen?.[this.device + '_img'] || this.staticdata.img?.[this.device + '_img'] || 'https://upload.wikimedia.org/wikipedia/commons/1/14/No_Image_Available.jpg';
    const img_preview = [
      {
        src: srcTemp,
        height: '90%',
        position: 'fixed',
      },
    ];
    this.nzImageService.preview(img_preview, { nzZoom: 0.9, nzRotate: 0 });
  }

  /**
 *  lấy width height của ảnh của từng thiết bị
    lấy width height của ảnh của thiết bị có width lớn nhất
  */
  getWidthHeightImage() {
    this.functionService.devices.forEach((device) => {
      device.width = parseFloat(
        Number(
          this.objectChoosing[device.value + '_class'][
            this.objectChoosing.resize_field
          ]['width'].replace('px', '')
        ).toFixed(0)
      );
      device.height = parseFloat(
        Number(
          this.objectChoosing[device.value + '_class'][
            this.objectChoosing.resize_field
          ]['height'].replace('px', '')
        ).toFixed(0)
      );
      if (this.widthImageMax < device.width) {
        this.widthImageMax = device.width;
        this.heightImageMax = device.height;
        this.imageDeviceWidthMax = device.value;
      }
    });
  }

  /** Xử lí xoay lật
   * @param axis : Lật theo trục 'x' | 'y' | 'z' | '-z'
   */
  handleSetTransform(axis) {
    switch (axis) {
      case 'x': // ---Lật dọc
        if (this.config['transform'].transform_rotateX < 360) {
          this.config['transform'].transform_rotateX += 180;
          this.class['image__boundary'].transform =
            'rotateX(' +
            this.config['transform'].transform_rotateX +
            'deg) ' +
            'rotateY(' +
            this.config['transform'].transform_rotateY +
            'deg) ' +
            'rotateZ(' +
            this.config['transform'].transform_rotateZ +
            'deg) ' +
            'skewX(' +
            this.config['transform'].transform_skewX +
            'deg) ' +
            'skewY(' +
            this.config['transform'].transform_skewY +
            'deg) ';
        } else {
          this.config['transform'].transform_rotateX -= 360;
          this.class['image__boundary'].transform =
            'rotateX(' +
            this.config['transform'].transform_rotateX +
            'deg) ' +
            'rotateY(' +
            this.config['transform'].transform_rotateY +
            'deg) ' +
            'rotateZ(' +
            this.config['transform'].transform_rotateZ +
            'deg) ' +
            'skewX(' +
            this.config['transform'].transform_skewX +
            'deg) ' +
            'skewY(' +
            this.config['transform'].transform_skewY +
            'deg) ';
        }
        break;
      case 'y': // ---Lật ngang
        if (this.config['transform'].transform_rotateY < 360) {
          this.config['transform'].transform_rotateY += 180;
          this.class['image__boundary'].transform =
            'rotateX(' +
            this.config['transform'].transform_rotateX +
            'deg) ' +
            'rotateY(' +
            this.config['transform'].transform_rotateY +
            'deg) ' +
            'rotateZ(' +
            this.config['transform'].transform_rotateZ +
            'deg) ' +
            'skewX(' +
            this.config['transform'].transform_skewX +
            'deg) ' +
            'skewY(' +
            this.config['transform'].transform_skewY +
            'deg) ';
        } else {
          this.config['transform'].transform_rotateY -= 360;
          this.class['image__boundary'].transform =
            'rotateX(' +
            this.config['transform'].transform_rotateX +
            'deg) ' +
            'rotateY(' +
            this.config['transform'].transform_rotateY +
            'deg) ' +
            'rotateZ(' +
            this.config['transform'].transform_rotateZ +
            'deg) ' +
            'skewX(' +
            this.config['transform'].transform_skewX +
            'deg) ' +
            'skewY(' +
            this.config['transform'].transform_skewY +
            'deg) ';
        }
        break;
      case '-z': // --- Xoay trái
        if (this.config['transform'].transform_rotateZ > -360) {
          this.config['transform'].transform_rotateZ -= 45;
          this.class['image__boundary'].transform =
            'rotateX(' +
            this.config['transform'].transform_rotateX +
            'deg) ' +
            'rotateY(' +
            this.config['transform'].transform_rotateY +
            'deg) ' +
            'rotateZ(' +
            this.config['transform'].transform_rotateZ +
            'deg) ' +
            'skewX(' +
            this.config['transform'].transform_skewX +
            'deg) ' +
            'skewY(' +
            this.config['transform'].transform_skewY +
            'deg) ';
        }
        break;
      case 'z': // --- Xoay phải
        if (this.config['transform'].transform_rotateZ < 360)
          this.config['transform'].transform_rotateZ += 45;
        this.class['image__boundary'].transform =
          'rotateX(' +
          this.config['transform'].transform_rotateX +
          'deg) ' +
          'rotateY(' +
          this.config['transform'].transform_rotateY +
          'deg) ' +
          'rotateZ(' +
          this.config['transform'].transform_rotateZ +
          'deg) ' +
          'skewX(' +
          this.config['transform'].transform_skewX +
          'deg) ' +
          'skewY(' +
          this.config['transform'].transform_skewY +
          'deg) ';
        break;
      default:
    }
    if (this.type == 'admin') {
      if (!this.objectChoosing.hasOwnProperty('fieldUpdate')) this.objectChoosing['fieldUpdate'] = [];
      if (!this.functionService.objectsAndBlocksUpdated.some((ele) => ele._id == this.objectChoosing._id)) this.functionService.objectsAndBlocksUpdated.push(this.objectChoosing);
      if (!this.objectChoosing['fieldUpdate'].includes(this.device + '_class')) this.objectChoosing['fieldUpdate'].push(this.device + '_class');
      if (!this.objectChoosing['fieldUpdate'].includes(this.device + '_config')) this.objectChoosing['fieldUpdate'].push(this.device + '_config');
      return;
    }
    this.updateFields({
      [this.device + '_config']: this.config,
      [this.device + '_class']: this.class,
    });
  }
  //Hàm cập nhật giá trị transform
  SetTransform() {
    this.class['image__boundary'].transform =
      'rotateX(' +
      this.config['transform'].transform_rotateX +
      'deg) ' +
      'rotateY(' +
      this.config['transform'].transform_rotateY +
      'deg) ' +
      'rotateZ(' +
      this.config['transform'].transform_rotateZ +
      'deg) ' +
      'skewX(' +
      this.config['transform'].transform_skewX +
      'deg) ' +
      'skewY(' +
      this.config['transform'].transform_skewY +
      'deg) ';
  }

  changeImgType(type = 'img') {
    // nếu đối imgType thành dùng chung ảnh cho từng thiết bị thì lưu ảnh của thiết bị có width lớn nhất vào các thiết bị còn lại
    if (this.objectChoosing.setups.upload_image.display == 'shared') {
      this.functionService.devices.forEach((device) => {
        if (type == 'img') {
          this.staticdata.img[device.value + '_img'] = this.staticdata.img[this.device + '_img'];
        } else if (type == 'fullscreen') {
          this.staticdata.img_fullscreen[device.value + '_img'] = this.staticdata.img_fullscreen[this.device + '_img'];
        }
      });
    }


    this.updateStaticData();
    this.updateSetups();
  }

  /**
   * Cập nhật staticdata vào database.
   */
  updateStaticData() {
    // Gọi hàm truy vấn cơ sở dữ liệu ở đây
    this.vhQueryAutoWeb
      .updateObject(this.objectChoosing._id, { staticdata: this.staticdata })
      .then((bool) => {
        // console.log('updateObject', bool);
      });
  }

  /**
 * Cập nhật Setups vào database.
 */
  updateSetups() {

    // Gọi hàm truy vấn cơ sở dữ liệu ở đây
    this.vhQueryAutoWeb
      .updateObject(this.objectChoosing._id, { setups: this.objectChoosing.setups })
      .then((bool) => {
        // console.log('updateObject', bool);
      });
  }


  /** UPLOAD IMAGE */
  openUpload(type = 'img') {
    if (isPlatformBrowser(this.platformId)) {
      if (type == 'img') {
        document.getElementById('upload').click();
      } else if (type == 'fullscreen') {
        document.getElementById('uploadFullscreen').click();
      }
    }
    // inputVal;
  }
  /**
 * no-compress': Không nén ảnh sau khi tải lên
  'compress-screen': Nén ảnh sau khi tải lên, nén ảnh theo tỉ lệ màn hình của mỗi thiết bị
  'compress-frame': Nén ảnh sau khi tải lên, nén ảnh theo tỉ lệ màn hình của mỗi khung hình thiết bị
  */
  onUpload(e, type = 'img') {
    const file = e.target.files[0];
    const input = e.target as HTMLInputElement;

    if (file && file.type.startsWith('image/')) {
      this.processImageUpload(file, type);
    } else {
      if (!file.type.startsWith('image/')) {
        this.functionService.createMessage('warning', 'vui_long_chon_tep_hinh_anh_hop_le');
        return;
      }
    }

    // Đặt lại giá trị của trường tệp để kích hoạt sự kiện change lần sau
    input.value = '';
  }

  /**
   * Hàm xử lý khi người dùng kéo và thả (drop) một tệp vào vùng upload.
   * @param event
   */
  onFileDropped_upload(event: DragEvent, type = 'img') {
    event.preventDefault();
    this.dragging = false;
    const file = event.dataTransfer?.files[0];

    if (file && file.type.startsWith('image/')) {
      // Hiển thị preview
      const reader = new FileReader();
      reader.onload = () => {
        this.previewUploadUrl = reader.result as string;
      };
      reader.readAsDataURL(file);

      // Xử lý tệp hình ảnh
      this.processImageUpload(file, type);
    } else {
      if (!file.type.startsWith('image/')) {
        this.functionService.createMessage('warning', 'vui_long_keo_tep_hinh_anh_hop_le');
        return;
      }
    }
  }

  /**
   * Hàm xử lý tệp hình ảnh lên server
   * - Tải lên
   * - Kéo thả vào
   *
   * Nén ảnh:
   * - 'no-compress': Không nén ảnh sau khi tải lên
   * - 'compress-screen': Nén ảnh sau khi tải lên, nén ảnh theo tỉ lệ màn hình của mỗi thiết bị
   * - 'compress-frame': Nén ảnh sau khi tải lên, nén ảnh theo tỉ lệ màn hình của mỗi khung hình thiết bị
   * @param file File được kéo thả vào hoặc được tải lên
   */
  processImageUpload(file: File, type = 'img') {
    let compress_type = this.objectChoosing.setups.upload_image.compress_type;

    let resolution = {};
    switch (this.objectChoosing.setups.upload_image.compress_type) {
      case 'compress-screen':
        resolution = {
          width: this.resolution[this.device + '_width'],
          height: 0,
        };
        break;
      case 'compress-frame':
        const dimension = this.objectChoosing[`${this.device}_config`]?.dimension;
        if (
          dimension &&
          Object.keys(dimension).length > 0 &&
          typeof dimension.width === 'number' &&
          typeof dimension.height === 'number'
        ) {
          resolution = {
            width: dimension.width,
            height: dimension.height,
          };
        }
        else {
          const deviceItem = this.functionService.devices.find((device) => device.value == this.device);
          resolution = {
            width: deviceItem.width,
            height: deviceItem.height,
          };
        }
        break;
      case 'custom':
        resolution = {
          width: +(this.objectChoosing.setups.upload_image.compress_width ?? 100),
          height: +(this.objectChoosing.setups.upload_image.compress_height ?? 100),
        };
        compress_type = 'compress-frame';
        break;
    }

    this.vhImage
      .getImageFromDesktop_Autoweb(file, 'images/design/objects', {
        compress_type: compress_type,
        resolution: resolution,
      })
      .then((res: any) => {
        // console.log('res', res);
        if (res.vcode != 0) {
          this.functionService.createMessage(
            'error',
            `${this.languageService.translate('tai_anh_that_bai_ly_do')}: ${res.msg}`
          );
          return;
        }
        // nếu là dùng chung ảnh thì lưu ảnh vào các thiết bị
        // nếu không thì lưu ảnh vào thiết bị đang chọn
        if (this.objectChoosing.setups.upload_image.display == 'shared') {
          this.functionService.devices.forEach((device) => {
            if (type == 'img') {
              this.staticdata.img[device.value + '_img'] = res.data;
            } else if (type == 'fullscreen') {
              this.staticdata.img_fullscreen[device.value + '_img'] = res.data;
            }
          });
        } else {
          if (type == 'img') {
            this.staticdata.img[this.device + '_img'] = res.data;
          } else if (type == 'fullscreen') {
            this.staticdata.img_fullscreen[this.device + '_img'] = res.data;
          }
        }

        this.updateStaticData();
        this.functionService.createMessage('success', 'tai_anh_thanh_cong');
      });
  }

  /**
   * Hành động khi người dùng kéo file qua vùng upload (chưa thả).
   * @param event
   */
  onDragOver_upload(event: DragEvent) {
    event.preventDefault();
    this.dragging = true;
  }

  /**
   * Hành động khi người dùng rời con trỏ khỏi vùng upload mà chưa thả.
   */
  onDragLeave_upload() {
    this.dragging = false;
  }

  /**
   * Hàm mở ra hộp thoại chọn hình ảnh miễn phí
   */
  openImageFree(type = 'img') {
    this.visible_config_tool = false;
    const dialogRef = this.dialog.open(ChooseImageComponent, {
      width: '80vw',
      height: '90vh',
      disableClose: false,
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        // nếu là dùng chung ảnh thì lưu ảnh vào các thiết bị
        // nếu không thì lưu ảnh vào thiết bị đang chọn
        if (this.objectChoosing.setups.upload_image.display == 'shared') {
          this.functionService.devices.forEach((device) => {
            if (type == 'img') {
              this.staticdata.img[device.value + '_img'] = result;
            } else if (type == 'fullscreen') {
              this.staticdata.img_fullscreen[device.value + '_img'] = result;
            }
          });
        } else {
          if (type == 'img') {
            this.staticdata.img[this.device + '_img'] = result;
          } else if (type == 'fullscreen') {
            this.staticdata.img_fullscreen[this.device + '_img'] = result;
          }
        }

        this.updateStaticData();
        this.isShowConfirmPopup = true;
      }
      this.visible_config_tool = true;
    });
  }

  /**
   * Hàm mở ra hộp thoại chỉnh sửa hình ảnh
   */
  openEditImage() {
    this.visible_config_tool = false;
    const dialogRef = this.dialog.open(AtwEditImage, {
      width: '80vw',
      height: '90vh',
      disableClose: false,
      data: {
        objectChoosing: this.objectChoosing,
        staticdata: this.staticdata,
        device: this.device,
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      this.visible_config_tool = true;
    });
  }

  /**
   *Hàm update config vào database.
   */
  updateConfig() {
    this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, {
      [this.device + '_config']: this.config,
    });
  }
  /**
   * Hàm update object vào database.
   */
  updateFields(value) {
    this.vhQueryAutoWeb
      .updateObject(this.objectChoosing._id, value)
      .then((bool: any) => { });
  }
  /**
   *Hàm update class vào database.
   */
  updateClass() {
    this.vhQueryAutoWeb
      .updateObject(this.objectChoosing._id, {
        [this.device + '_class']: this.class,
      })
      .then((bool: any) => { });
  }
  /**
   * Hàm này dùng để cho phép mở menu config .
   * Khi mở ở vị trí menu[0] thì các menu khác (menu[n]) đóng lại.
   * @param: value
   */
  openMap: { [name: string]: boolean; } = {
    menu1: false,
    menu2: true,
    menu3: false,
    menu4: false,
    menu5: false,
    menu6: false,
    menu7: false,
    menu8: false,
    menu9: false,
  };
  openMapSub: { [name: string]: boolean; } = { menu1: true, menu2: false };
  openHandler(value: string, isSub = false): void {
    const targetMap = isSub ? this.openMapSub : this.openMap;
    Object.keys(targetMap).forEach(key => {
      if (key !== value) targetMap[key] = false;
    });
  }

  /** Áp dụng đổ bóng
   *   * -> xử lí dữ liệu bóng -> css:  box-shadow: `x y blur color`
   */
  handleSetShadow() {
    if (this.config.check_shadow == false)
      this.class['image__boundary--img']['box-shadow'] = 'none';
    else {
      this.class['image__boundary--img'].transform = 0.8;
      this.class['image__boundary--img'][
        'box-shadow'
      ] = `${this.config['box-shadow'].box_shadow_x}px ${this.config['box-shadow'].box_shadow_y}px ${this.config['box-shadow'].box_shadow_blur}px ${this.config['box-shadow'].box_shadow_color}`;
    }

    if (this.type == 'admin') {
      if (!this.objectChoosing.hasOwnProperty('fieldUpdate')) this.objectChoosing['fieldUpdate'] = [];
      if (!this.functionService.objectsAndBlocksUpdated.some((ele) => ele._id == this.objectChoosing._id)) this.functionService.objectsAndBlocksUpdated.push(this.objectChoosing);
      if (!this.objectChoosing['fieldUpdate'].includes(this.device + '_class')) this.objectChoosing['fieldUpdate'].push(this.device + '_class');
      if (!this.objectChoosing['fieldUpdate'].includes(this.device + '_config')) this.objectChoosing['fieldUpdate'].push(this.device + '_config');
      return;
    }

    this.updateFields({
      [this.device + '_config']: this.config,
      [this.device + '_class']: this.class,
    });
  }
  /** Xử lí đổ bóng
   * -> xử lí dữ liệu bóng -> css:  object-position: `x y blur color`
   */
  handleSetPositionShadow() {
    this.class['image__boundary--img'][
      'box-shadow'
    ] = `${this.config['box-shadow'].box_shadow_x}px ${this.config['box-shadow'].box_shadow_y}px ${this.config['box-shadow'].box_shadow_blur}px ${this.config['box-shadow'].box_shadow_width}px ${this.config['box-shadow'].box_shadow_color}`;
    if (this.type == 'admin') {
      if (!this.objectChoosing.hasOwnProperty('fieldUpdate')) this.objectChoosing['fieldUpdate'] = [];
      if (!this.functionService.objectsAndBlocksUpdated.some((ele) => ele._id == this.objectChoosing._id)) this.functionService.objectsAndBlocksUpdated.push(this.objectChoosing);
      if (!this.objectChoosing['fieldUpdate'].includes(this.device + '_class')) this.objectChoosing['fieldUpdate'].push(this.device + '_class');
      if (!this.objectChoosing['fieldUpdate'].includes(this.device + '_config')) this.objectChoosing['fieldUpdate'].push(this.device + '_config');
      return;
    }
    this.updateFields({
      [this.device + '_config']: this.config,
      [this.device + '_class']: this.class,
    });
  }
  /**
   * Hàm này dùng để mở rộng phần cấu hình.
   * @param field_text : trả về phần tử được chọn của mảng style_field
   */
  openViewAll(field_text) {
    this.currentViewAll = field_text;
    this.isViewAll = !this.isViewAll;
  }
  /**
   * remove link khi click vào nút x
   */
  removeLink() {
    this.staticdata.hyper_link = '';
    this.updateStaticData();
  }

  public urlBackgroundImage = ''; // Giá trị đường dẫn của background-image
  /** Hàm thực hiện xử lí khi chuyển lựa chon background
   *
   * @param event
   */
  handleSetBackground(event) {
    let frameBlank = this.config['image'];
    if (event === 'color') {
      if (this.class['image']['background-color'] == 'transparent') {
        this.class['image']['background-color'] =
          frameBlank['background_color_restore'];
      }
      this.class['image']['background-image'] = 'none';
    }
    if (event === 'image') {
      if (frameBlank['background-image'] == 'none') {
        this.class['image']['background-image'] =
          frameBlank['background_image_restore'];

        // Xử lí cắt chuỗi background-image
        let backgroundImage = this.class['image']['background-image'];
        const startIndex = backgroundImage.indexOf('(') + 1; // Tìm vị trí bắt đầu của phần tử aaa
        const endIndex = backgroundImage.lastIndexOf(')');
        this.urlBackgroundImage = backgroundImage.substring(
          startIndex,
          endIndex
        ); // Cắt phần tử url từ vị trí bắt đầu đến kết thúc
      }
      this.class['image']['background-color'] = 'transparent';
    }
    setTimeout(() => {
      this.updateClass();
      this.updateConfig();
    }, 0);
  }

  /** Hàm thực hiện gán giá trị background-image khi có thay đổi
   *
   */
  handleSetBackgroundImage() {
    this.class['image']['background-image'] = this.class['image'][
      'background_image_restore'
    ] = `url(${this.urlBackgroundImage})`;
    this.updateClass();
  }
  path = '';
  /**
   * Hàm xử lý lấy ảnh ở thư viện
   */
  openLibrary(type = 'img') {
    const dialogRef = this.matdialog.open(ManageLibraryComponent, {
      width: '85%',
      maxWidth: '100%',
      data: {
        startPath: this.path || '/images/design/objects',
        scopeData: '/images',
      },
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe((data) => {
      if (data.href) {
        // nếu là dùng chung ảnh thì lưu ảnh vào các thiết bị
        // nếu không thì lưu ảnh vào thiết bị đang chọn
        if (this.objectChoosing.setups.upload_image.display == 'shared') {
          this.functionService.devices.forEach((device) => {
            if (type == 'img') {
              this.staticdata.img[device.value + '_img'] = data.href;
            } else if (type == 'fullscreen') {
              this.staticdata.img_fullscreen[device.value + '_img'] = data.href;
            }
          });
        } else {
          if (type == 'img') {
            this.staticdata.img[this.device + '_img'] = data.href;
          } else if (type == 'fullscreen') {
            this.staticdata.img_fullscreen[this.device + '_img'] = data.href;
          }
        }

        this.updateStaticData();
      }
      this.path = data.path;
    });
  }

  /** Xử lí lưu vị trí ảnh
   * -> xử lí dữ liệu bóng -> css:  object-position: `x y`
   */
  handleSetPositionImage() {
    this.class['image__boundary--img'][
      'object-position'
    ] = `-${this.config.image.object_x}px -${this.config.image.object_y}px`;
    if (this.type == 'admin') {
      if (!this.objectChoosing.hasOwnProperty('fieldUpdate')) this.objectChoosing['fieldUpdate'] = [];
      if (!this.functionService.objectsAndBlocksUpdated.some((ele) => ele._id == this.objectChoosing._id)) this.functionService.objectsAndBlocksUpdated.push(this.objectChoosing);
      if (!this.objectChoosing['fieldUpdate'].includes(this.device + '_class')) this.objectChoosing['fieldUpdate'].push(this.device + '_class');
      if (!this.objectChoosing['fieldUpdate'].includes(this.device + '_config')) this.objectChoosing['fieldUpdate'].push(this.device + '_config');
      return;
    }
    this.updateFields({
      [this.device + '_config']: this.config,
      [this.device + '_class']: this.class,
    });
  }

  //Hàm xử lý scale
  scale() {
    this.class['image__boundary--img'][
      'transform'
    ] = `scale(${this.class['image__boundary--img']['transfrom_scale']})`;
    this.updateClass();
  }

  /**
   * Hàm này set customize mở phần mở rộng của config từ choose-animations-config truyền về
   * @param event customize sau khi thay đổi
   */
  openAnimationDetail(event) {
    var effect =
      this.objectChoosing[this.device + '_config']['animation-selected'];

    this.class['image__boundary'].transform = '';
    this.class['image']['box-shadow'] = '';
    if (effect.id == '000010') {
      this.class['image__boundary--img']['height'] = '';
    } else if (effect.id == '000007') {
      this.class['image__boundary--img']['filter'] = '';
    } else {
      this.class['image__boundary--img']['height'] = '100%';
      this.class['image__boundary--img']['filter'] =
        'brightness(100%)  contrast(100%)  saturate(100%)   hue-rotate(0deg)   blur(0px)   opacity(100%)   grayscale(0%)';
    }

    this.customize = event;

    if (this.config['animation-selected'].id != '000000') {
      this.openViewAll(this.style_fields[5]);
    }
  }

  /**
   * hàm này nhận sk thay đổi width height từ component app-width-height-config truyền về
   * @param event width hieght của element sau khi thay đổi
   */
  changeWidthHeight(event) {
    if (event.width) this.class['image']['width'] = event.width + 'px';
    if (event.height) this.class['image']['height'] = event.height + 'px';
    this.vhEventMediator.notifyOnConfigChanged({
      status: 'update-object-selected-ruler',
      code: this.objectChoosing._id,
    });
    this.updateClass();
  }

  handleCancelConfirm() {
    this.isShowConfirmPopup = false;
  }

  /**
   * Lấy hình ảnh từ url đẩy lên server với kích thước hình thay đổi
   * */
  handleOkConfirm(type = 'img') {
    this.isConfirmLoading = true;

    let compress_type = this.objectChoosing.setups.upload_image.compress_type;

    let resolution = {};
    switch (this.objectChoosing.setups.upload_image.compress_type) {
      case 'compress-screen':
        resolution = {
          width: this.resolution[this.device + '_width'],
          height: 0,
        };
        break;
      case 'compress-frame':
        const dimension = this.objectChoosing[`${this.device}_config`]?.dimension;
        if (
          dimension &&
          Object.keys(dimension).length > 0 &&
          typeof dimension.width === 'number' &&
          typeof dimension.height === 'number'
        ) {
          resolution = {
            width: dimension.width,
            height: dimension.height,
          };
        }
        else {
          const deviceItem = this.functionService.devices.find((device) => device.value == this.device);
          resolution = {
            width: deviceItem.width,
            height: deviceItem.height,
          };
        }
        break;
      case 'custom':
        resolution = {
          width: +(this.objectChoosing.setups.upload_image.compress_width ?? 100),
          height: +(this.objectChoosing.setups.upload_image.compress_height ?? 100),
        };
        compress_type = 'compress-frame';
        break;
    }

    if (type == 'fullscreen') {
      compress_type = 'compress-screen';
      resolution = {
        width: this.resolution[this.device + '_width'],
        height: 0,
      };
    }

    const url = type == 'fullscreen'
      ? this.staticdata.img_fullscreen[this.device + '_img']
      : this.staticdata.img[this.device + '_img'];

    this.vhImage
      .getImageFromURL_Autoweb(
        url,
        'images/design/objects',
        {
          compress_type: compress_type,
          resolution: resolution,
        }
      )
      .then((rsp: any) => {
        if (rsp.vcode == 0) {
          // nếu là dùng chung ảnh thì lưu ảnh vào các thiết bị
          // nếu không thì lưu ảnh vào thiết bị đang chọn
          if (this.objectChoosing.setups.upload_image.display == 'shared') {
            this.functionService.devices.forEach((device) => {
              if (type == 'img') {
                this.staticdata.img[device.value + '_img'] = rsp.data;
              } else if (type == 'fullscreen') {
                this.staticdata.img_fullscreen[device.value + '_img'] = rsp.data;
              }
            });
          } else {
            if (type == 'img') {
              this.staticdata.img[this.device + '_img'] = rsp.data;
            } else if (type == 'fullscreen') {
              this.staticdata.img_fullscreen[this.device + '_img'] = rsp.data;
            }
          }
          this.updateStaticData();
          this.functionService.createMessage('success', 'tai_anh_thanh_cong');
        } else {
          this.functionService.createMessage('error', this.languageService.translate('tai_anh_that_bai_ly_do') + rsp.msg);
        }
      })
      .catch((error) => {
        if (error.message && error.message.includes('413')) {
          // Thông báo cho người dùng
          this.functionService.createMessage(
            'error',
            'file_anh_qua_lon_vui_chon_file_anh_co_dung_luong_nho_hon_1mb'
          );
        }
      });
    this.isConfirmLoading = false;
    this.isShowConfirmPopup = false;
  }

  changeUrl(type = 'img') {
    // nếu là dùng chung ảnh thì lưu ảnh vào các thiết bị
    // nếu không thì lưu ảnh vào thiết bị đang chọn
    if (this.objectChoosing.setups.upload_image.display == 'shared') {
      this.functionService.devices.forEach((device) => {
        if (type == 'img') {
          this.staticdata.img[device.value + '_img'] = this.staticdata.img[this.device + '_img'];
        } else if (type == 'fullscreen') {
          this.staticdata.img_fullscreen[device.value + '_img'] = this.staticdata.img_fullscreen[this.device + '_img'];
        }
      });
    }

    if (this.type == 'admin') {
      if (!this.objectChoosing.hasOwnProperty('fieldUpdate')) this.objectChoosing['fieldUpdate'] = [];
      if (!this.functionService.objectsAndBlocksUpdated.some((ele) => ele._id == this.objectChoosing._id)) this.functionService.objectsAndBlocksUpdated.push(this.objectChoosing);
      if (!this.objectChoosing['fieldUpdate'].includes('staticdata')) this.objectChoosing['fieldUpdate'].push('staticdata');
      if (!this.objectChoosing['fieldUpdate'].includes('setups')) this.objectChoosing['fieldUpdate'].push('setups');
      return;
    }
    this.updateFields({
      staticdata: this.staticdata,
      setups: this.objectChoosing.setups,
    });

  }

  updateClassAndConfig() {
    if (this.type == 'admin') {
      if (!this.objectChoosing.hasOwnProperty('fieldUpdate')) this.objectChoosing['fieldUpdate'] = [];
      if (!this.functionService.objectsAndBlocksUpdated.some((ele) => ele._id == this.objectChoosing._id)) this.functionService.objectsAndBlocksUpdated.push(this.objectChoosing);
      if (!this.objectChoosing['fieldUpdate'].includes(this.device + '_class')) this.objectChoosing['fieldUpdate'].push(this.device + '_class');
      if (!this.objectChoosing['fieldUpdate'].includes(this.device + '_config')) this.objectChoosing['fieldUpdate'].push(this.device + '_config');
      return;
    }
    this.updateFields({
      [this.device + '_config']: this.config,
      [this.device + '_class']: this.class,
    });
  }

  /**
   * Lấy ra tên file và đuôi file
   * @param url Đường dẫn ảnh
   * @example const { fileName, fileExtension } = getFileInfo("https://115.78.228.208:20350/autowebapp/67c1b593b1344364462b082b/images/design/objects/3-1-768x768%20(3).png");
   */
  getFileInfo(url: string) {
    const decodedUrl = decodeURIComponent(url);
    const parts = decodedUrl.split('/');

    // Lấy tên file (phần cuối)
    const fullFileName = parts.pop() || '';
    const dotIndex = fullFileName.lastIndexOf('.');

    // Tìm và lấy phần giữa (ví dụ: "images/design/objects")
    const indexImages = parts.indexOf('images');
    const folderPath =
      indexImages !== -1 ? parts.slice(indexImages).join('/') : '';

    return {
      fullFileName, // ví dụ: "3-1-768x768 (3).png"
      fileName: fullFileName.substring(0, dotIndex), // "3-1-768x768 (3)"
      fileExtension: fullFileName.substring(dotIndex + 1), // "png"
      folderPath, // "images/design/objects"
    };
  }

  /**
   * Sao chép đường dẫn hình ảnh vào bộ nhớ tạm
   */
  copyLinkImg(text?: string) {
    if (isPlatformBrowser(this.platformId)) {
      const textCopy = text || this.staticdata.img[this.device + '_img'];
      navigator.clipboard.writeText(textCopy)
        .then(() => {
          this.functionService.createMessage('success', 'da_sao_chep_vao_bo_nho_tam', 2000);
        })
        .catch(err => {
          this.functionService.createMessage('error', 'loi_khi_sao_chep', 2000);
          console.error('❌ Lỗi khi copy:', err);
        });
    }
  }

  /** Hàm kiểm tra có cần phải hiển thị nút cập nhật không */
  private async checkDesignImageSize() {
    // chạy song song cho nhanh
    const results = await Promise.all(this.functionService.devices.map(async d => {
      // Nếu thiết bị là desktop và dự án là app thì không cần check
      if (d.value == 'desktop' && this.subproject?.style == 'app') return false;
      // Nếu giao diện thiết kế đã ẩn thiết bị thì không cần check
      if (!this.subproject?.[`${d.value}_template_display`]) return false;

      // Ảnh gốc
      const url = this.staticdata.img[`${d.value}_img`];
      const imgSize = await this.functionService.getImageSize(url);
      // Container thiết kế
      const container = this.objectChoosing[`${d.value}_class`].image;
      const containerSize = {
        width: parseFloat(container.width),
        height: parseFloat(container.height),
      };

      return this.functionService.checkRatioDesignImgSize(imgSize, containerSize);
    }));

    // chỉ cần 1 device trả về true → return true
    return results.some(v => v === true);
  }

  /**
   * Hàm update kích thước ảnh phù hợp cho từng kích thước thiết kế của từng thiết bị
   */
  async updateDesignImageSize() {
    const messages: { type: 'success' | 'warning' | 'error', msg: string, duration?: number; }[] = [];

    // ⭐ Show Loading 1 lần duy nhất
    await this.functionService.showLoading("", "current-loading", null, 0, false);

    await Promise.all(
      this.functionService.devices.map(async d => {
        // Nếu thiết bị là desktop và dự án là app thì không cần check
        if (d.value == 'desktop' && this.subproject.style == 'app') return;
        // Nếu giao diện thiết kế đã ẩn thiết bị thì không cần check
        if (!this.subproject[`${d.value}_template_display`]) return;

        /** Khai báo tin nhắn thông báo cho từng thiết bị */
        const msgDevices = `(${this.languageService.translate('thiet_bi')} ${this.languageService.translate(d.label)}) `;

        // Ảnh gốc
        const url = this.staticdata.img[`${d.value}_img`];

        // Trường hợp đường dẫn không có hoặc rỗng
        if (!url) {
          messages.push({
            type: 'warning',
            msg: msgDevices + this.languageService.translate('chua_truyen_duong_dan_anh')
          });
          return;
        }

        // Trường hợp chưa up lên server đây là bước bắt buộc
        // vì cần phải giữ một ảnh gốc để sau này có resize ảnh thì còn cần ảnh gốc để nén lại
        if (!url.includes(this.id_subproject)) {
          messages.push({
            type: 'warning',
            msg: msgDevices + this.languageService.translate('anh_nay_chua_chuyen_len_server')
          });
          return;
        }

        const imgSize = await this.functionService.getImageSize(url);

        // Container thiết kế
        const container = this.objectChoosing[`${d.value}_class`].image;
        const containerSize = {
          width: parseFloat(container.width),
          height: parseFloat(container.height),
        };

        // Trường hợp nếu ảnh này đã phù hợp thì trả về thông báo chứ không update nữa
        if (!this.functionService.checkRatioDesignImgSize(imgSize, containerSize)) {
          messages.push({
            type: 'warning',
            msg: msgDevices + this.languageService.translate('anh_nay_da_phu_hop_khong_can_cap_nhat_nua')
          });
          return;
        }

        const msgSolution = this.type == 'admin'
          ? 'vui_long_chuan_bi_mot_hinh_khac_phu_hop'
          : 'vui_long_sua_thiet_ke_hoac_chuan_bi_mot_hinh_khac_phu_hop';

        // Trường hợp đã cập nhật hoặc width là bằng sẵn rồi nhưng height thiết kế không phù hợp
        // Thì trả về thông báo chứ không cho update nữa vì gây tăng dung lượng lưu ảnh không cần thiết
        if (
          imgSize.width == containerSize.width &&
          imgSize.height != containerSize.height
        ) {
          const mTmp = containerSize.height > imgSize.height
            ? 'chieu_cao_thiet_ke_lon_hon_chieu_cao_anh'
            : 'chieu_cao_thiet_ke_nho_hon_chieu_cao_anh';
          const m = this.languageService.translate(mTmp) + '. ' + this.languageService.translate(msgSolution);
          messages.push({
            type: 'error',
            msg: msgDevices + m + '!!!',
            duration: 8000
          });
          return;
        }

        // Trường hợp nếu ảnh này bé hơn kích thước thiết kế thì báo cho người dùng và không cập nhật
        if (imgSize.width < containerSize.width) {
          const mTmp = 'chieu_dai_anh_nho_hon_chieu_dai_thiet_ke_lam_cho_viec_nen_anh_theo_khung_hien_thi_hinh_anh_khong_hoat_dong';
          const m = this.languageService.translate(mTmp) + '. ' + this.languageService.translate(msgSolution);
          messages.push({
            type: 'error',
            msg: msgDevices + m + '!!!',
            duration: 8000
          });
          return;
        }

        // Cập nhật ảnh cho từng thiết bị
        try {
          const rsp: any = await this.vhImage.getImageFromURL_Autoweb(
            url,
            'images/design/objects',
            {
              compress_type: 'compress-frame',
              resolution: containerSize,
            }
          );

          if (rsp.vcode == 0) {
            this.staticdata.img[d.value + '_img'] = rsp.data;

            messages.push({
              type: 'success',
              msg: msgDevices + this.languageService.translate('tai_anh_thanh_cong')
            });
          } else {
            messages.push({
              type: 'error',
              msg: msgDevices + this.languageService.translate('tai_anh_that_bai_ly_do') + rsp.msg
            });
          }
        } catch (error: any) {
          if (error.message?.includes('413')) {
            messages.push({
              type: 'error',
              msg: msgDevices + this.languageService.translate('file_anh_qua_lon_vui_chon_file_anh_co_dung_luong_nho_hon_1mb')
            });
          }
        }
      })
    );

    // CHỈ CHẠY SAU KHI HOÀN TẤT TẤT CẢ DEVICE
    this.updateStaticData();

    // ⭐ Hide loading (delay 200ms để tránh flick)
    await this.functionService.hideLoading(200);

    // Show toàn bộ message sau cùng
    messages.forEach(m => {
      this.functionService.createMessage(m.type, m.msg, m.duration ?? 5000);
    });
  }
}
